/* src/app/modules/shared/components/header-column/header-column-top-flavor/header-column-top-flavor.component.scss */
app-header-column-top-flavor {
  display: contents;
}
/*# sourceMappingURL=header-column-top-flavor.component.css.map */
